"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const child_process_1 = require("child_process");
const cli_core_1 = require("@/cli-core");
const cli_api_1 = require("@/cli-api");
const lang_1 = require("@/service/lang");
const commands_json_1 = __importDefault(require("@/config/commands.json"));
const CLIConfig = commands_json_1.default;
cli_core_1.CLI.loading.start(lang_1.Lang.BUILDIN.CORE_STRTUP_READY);
// 判断是否为 VS Code 本地调试环境
const isDebug = process.env.DEBUG_ENV === 'true';
const globalNpmRoot = cli_core_1.ChildProcess.runCmdSync('npm root -g');
// 如果是本地调试，根目录指向当前项目根目录；否则指向全局包目录
const debugPath = cli_api_1.fs.join(cli_api_1.fs.join(__dirname).split('coda-cli')[0], 'coda-cli');
let currentProjectRoot = isDebug ? debugPath : cli_api_1.fs.join(globalNpmRoot, CLIConfig.packageName);
const outputPath = cli_api_1.fs.readFile(cli_api_1.fs.join(currentProjectRoot, 'package.json'), true)['output']; //读取构建输出的路径
let npmRootPath = isDebug ? currentProjectRoot : globalNpmRoot;
let cliRoootPath = currentProjectRoot;
/**
 * 把coda-cli和npm的实际路径写入node环境变量
 * 命令调试时使用cliRoootPath路径
 * 生产环境使用globalNpmRoot路径
 */
process.env.cliRoootPath = cliRoootPath;
process.env.globalNpmRoot = globalNpmRoot;
/**
 * 获取 CLI 配置对象
 */
function getCLIConfig() {
    return {
        packageName: commands_json_1.default.packageName,
        wordsLen: commands_json_1.default.wordsLen,
        name: commands_json_1.default.name,
        commands: commands_json_1.default.commands,
        inAnyPath: commands_json_1.default.inAnyPath,
        buildIn: commands_json_1.default.buildIn,
        store: commands_json_1.default.store,
        aiSetting: commands_json_1.default.aiSetting,
    };
}
/**
 * 显示帮助信息
 * @param name CLI 名称
 * @param commands 命令列表
 */
function showHelp(name, commands) {
    let helpList = [];
    commands.forEach(cmd => {
        helpList.push(`${name} ${cmd.command} : ${cmd.description}`);
    });
    helpList.push(name + ' ' + lang_1.Lang.HELP_MESSAGE);
    const helps = `Usage: ${name} [command] \nCommands:\n\t${helpList.join('\n\t')}`;
    cli_core_1.CLI.loading.succeed(lang_1.Lang.BUILDIN.CLI_HAS_READY);
    cli_core_1.CLI.log.info(helps);
    process.exit(0);
}
/**
 * 检查是否存在相似或匹配的命令
 * @param input 输入的命令
 * @param commands 命令列表
 */
function hasLikeCommand(input, commands) {
    let exsited = false;
    let likeList = commands.filter(cmd => {
        if (cmd['command'] === input) {
            exsited = true;
            return false;
        }
        else {
            let temp = input.split(' ');
            if (cmd['command'].includes(temp[0])) {
                return true;
            }
            return false;
        }
    });
    return {
        exsited,
        likeList,
    };
}
/**
 * 验证命令合法性
 * @param option 选项/输入内容
 * @param name CLI 名称
 * @param commands 命令列表
 */
function validateCommand(option, name, commands) {
    const { exsited, likeList } = hasLikeCommand(option, commands);
    if (!exsited) {
        let formatVal = option.toLowerCase();
        switch (formatVal) {
            case '--h':
                showHelp(name, commands);
                break;
            default:
                if (likeList.length !== 0) {
                    let likes = [];
                    likeList.forEach(cmd => {
                        likes.push(`${name} ${cmd.command}`);
                    });
                    if (likes.length !== 0) {
                        cli_core_1.CLI.loading.succeed(lang_1.Lang.BUILDIN.CLI_HAS_READY);
                        cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.BUILDIN.NO_COMMAND} "${name} ${option}"`, `${lang_1.Lang.BUILDIN.MEAN_SUCH}\n\t${likes.join('\n\t')}`);
                        process.exit();
                    }
                }
                else {
                    cli_core_1.CLI.loading.succeed(lang_1.Lang.BUILDIN.CLI_HAS_READY);
                    cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.BUILDIN.NO_COMMAND} "${name} ${option}".`);
                    process.exit();
                }
                break;
        }
    }
    return {
        exsited,
        likeList,
    };
}
/**
 * 检查并自动更新 CLI 或相关依赖
 */
async function autoUpdate() {
    let pkgPath = cli_api_1.fs.join(cliRoootPath, outputPath, 'package.json'); // 找到 CLI 自身的 PKG，真实位置在 NPM 全局安装目录下
    cli_core_1.CLI.loading.start(lang_1.Lang.BUILDIN.CORE_CHECKING_UPDATE);
    let pkgJSON = cli_api_1.fs.readFile(pkgPath, true);
    let storeUrl = CLIConfig.store;
    let url = cli_api_1.fs.join(storeUrl, CLIConfig.packageName);
    let cliVersion = await cli_api_1.packages.checkVersion(url, pkgJSON.version);
    if (JSON.stringify(cliVersion) === '{}') {
        cli_core_1.CLI.loading.info(lang_1.Lang.BUILDIN.CORE_LATEST_VERSION);
        /** 以下是检测 code-agent 依赖包版本的预留逻辑 */
    }
    else {
        cli_core_1.CLI.loading.info(lang_1.Lang.BUILDIN.CORE_UPDATE_READY); // 升级 CLI 需要切换目录到 NPM 全局安装目录
        cli_core_1.CLI.log.printObject(cliVersion);
        const task = 'npm install -g code-agent --loglevel info --timing';
        if (process.platform === 'win32') {
            cli_core_1.ChildProcess.runCmdNewWindow(task, npmRootPath, true);
        }
        else {
            cli_core_1.CLI.log.warn(lang_1.Lang.BUILDIN.CORE_LINUX_INPUT_ROOT_USER_PASSWORD);
            cli_core_1.ChildProcess.runCmdNewWindow(`sudo ${task}`, npmRootPath, true);
        }
    }
}
/**
 * 引导和执行命令的主逻辑
 */
async function guideCommand() {
    const { wordsLen, name, commands, inAnyPath, buildIn } = getCLIConfig();
    const currArgs = process.argv.slice(2);
    const cmdLen = currArgs.length;
    if (cmdLen === 0) {
        showHelp(name, commands);
    }
    if (cmdLen <= wordsLen) {
        let cmdOptions = currArgs.join(' ');
        let main = `${cli_api_1.fs.join('extensions', currArgs.join('-'), 'index.js')}`;
        if (buildIn.includes(cmdOptions)) {
            main = `${cli_api_1.fs.join('generator', currArgs.join('-'), 'index.js')}`;
        }
        const { exsited } = validateCommand(cmdOptions, name, commands);
        if (exsited) {
            let baseEnvConfig = JSON.stringify({
                input: cmdOptions,
                commands,
                wordsLen,
                name,
                inAnyPath,
            });
            process.env['CLI_ENV'] = baseEnvConfig;
            cli_core_1.CLI.loading.succeed(lang_1.Lang.BUILDIN.CLI_VOLIDATE_CMD_SUCCESS);
            const loadProgram = () => {
                let programPath = isDebug
                    ? cli_api_1.fs.join(currentProjectRoot, outputPath, main)
                    : cli_api_1.fs.join(globalNpmRoot, CLIConfig.packageName, outputPath, main); //访问打包后的路径
                let child = (0, child_process_1.fork)(programPath, [npmRootPath], {
                    silent: false,
                });
                child.on('error', (error) => {
                    console.clear();
                    cli_core_1.CLI.log.error(error.message, error.stack);
                    autoUpdate();
                });
                child.on('exit', (code) => {
                    if (code === 0) {
                        autoUpdate();
                    }
                });
            };
            loadProgram();
        }
        else {
            cli_core_1.CLI.loading.succeed(lang_1.Lang.BUILDIN.CLI_HAS_READY);
            cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.BUILDIN.NO_COMMAND} "${name} ${currArgs.join(' ')}"`);
            process.exit();
        }
    }
    else {
        cli_core_1.CLI.loading.succeed(lang_1.Lang.BUILDIN.CLI_HAS_READY);
        cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, lang_1.Lang.BUILDIN.COMMAND_LENGTH_TOO_LONG);
        process.exit();
    }
}
guideCommand();
